export const getSources = (state) => state.sources
